module.exports = __webpack_public_path__ + "img/main.c430c551.png";